import { jsx } from "react/jsx-runtime";
import { lightModeTone, darkModeTone } from "../../css/typography.css.mjs";
const textTones = [
  lightModeTone.light,
  darkModeTone.dark
].join(" ");
const VanillaThemeContainer = ({
  children,
  theme,
  setDefaultTextTones
}) => /* @__PURE__ */ jsx("div", { className: `${theme}${setDefaultTextTones ? ` ${textTones}` : ""}`, children });
export {
  VanillaThemeContainer
};
